export enum AssignmentObjectStatus {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
}
